





































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { OPEN_URL, WPS_DOCS, PRIVACY_URL, PRIVACY_ACCOUNT_URL } from '@/apps/open/constants'
import { detectMob } from '@/apps/open/utils'

@Component
export default class Agreement extends Vue {
  /**
   * 打开开放平台
   */
  toOpen () {
    window.open(OPEN_URL)
  }

  /**
   * 打开WPS文档
   */
  toDocs () {
    window.open(WPS_DOCS)
  }

  toPrivacy () {
    window.open(PRIVACY_URL)
  }

  toPrivacyAccount () {
    window.open(PRIVACY_ACCOUNT_URL)
  }
}
